import {
  CenteredFadeInSpinner,
  CenteredMessage,
} from '@tableau/data-catalog-shared';
import * as React from 'react';
import { Query } from 'react-apollo';

import { Messages } from '../../../gen-src/Localize';
import { VirtualConnectionQuery, VirtualConnectionQuery_virtualConnections, VirtualConnectionQueryVariables } from '../../../gen-src/queries/VirtualConnectionQuery';
import { VirtualConnectionQueryGql } from '../../queries/VirtualConnectionQueryGql';
import { renderQueryResult } from '../renderQueryResult';
import { createRenderDataWithErrorFunction, renderError, renderNoData } from '../widgets/ErrorMessageWidgets';

export type VirtualConnectionQueryWrapperProps = {
  readonly vizportalUrlId: string;
  readonly children: (result: VirtualConnectionQuery_virtualConnections) => React.ReactNode;
};

export class VirtualConnectionQueryWrapper extends React.Component<VirtualConnectionQueryWrapperProps> {

  public render(): React.ReactNode {
    return (
      <Query<VirtualConnectionQuery, VirtualConnectionQueryVariables>
        query={VirtualConnectionQueryGql}
        variables={{ vizportalUrlId: this.props.vizportalUrlId }}
      >
        {result => renderQueryResult(result, {
          renderLoading: () => <CenteredFadeInSpinner />,
          renderData: this.renderVirtualConnectionData,
          renderNoData: renderNoData,
          renderDataWithError: createRenderDataWithErrorFunction(this.renderVirtualConnectionData),
          renderError: renderError,
        })}
      </Query>
    );
  }

  private readonly renderVirtualConnectionData = (data: VirtualConnectionQuery): React.ReactNode => {
    const virtualConnection = data.virtualConnections ? data.virtualConnections[0] : null;
    if (virtualConnection) {
      return this.props.children(virtualConnection);
    } else {
      return <CenteredMessage message={Messages.ErrorItemNotFound()} />;
    }
  }

}
